import { useState, useEffect, useCallback, useRef } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Button,
  Label,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import avatar from "../../../assets/images/nav4.svg";
import {
  useNavigate,
  useParams,
  useLocation,
  json,
  Link,
} from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";
import newImgIcon from "../../../assets/images/Plus.png";
import Autocomplete from "react-google-autocomplete";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import debounce from "lodash.debounce";
import Select from "react-select";
import { useSelector } from "react-redux";
import { ImageDrop } from "quill-image-drop-module";
import ReactQuill, { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";
import "react-quill/dist/quill.snow.css";
Quill.register("modules/resize", QuillResizeImage);
Quill.register("modules/imageDrop", ImageDrop);

const AddGyms = () => {
  document.title = " Add Gym | Elevated Iron - Admin Dashboard";
  const { currentUser } = useSelector((state) => state.auth);
  const { id } = useParams();
  const navigate = useNavigate();
  const location1 = useLocation();
  const [workingHours, setWorkingHours] = useState([
    { openTime: "", closeTime: "", workingDay: "", isFullDay: false },
  ]);
  const [mediaFiles, setMediaFiles] = useState({ files: [null] });
  const [day, setDay] = useState(false);
  const [equipment, setEquipment] = useState([]);
  const [logoFiles, setLogoFiles] = useState(null);
  const [ownerSearch, setOwnerSearch] = useState([]);
  const [ownerSearchTxt, setOwnerSearchTxt] = useState("");
  const [ownerloading, setOwnerloading] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedItem, setSelectedItem] = useState(false);
  const [apiError, setApiError] = useState("");
  const [formError, setFormError] = useState("");
  const [logoError, setLogoError] = useState("");
  const [clickCount, setClickCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [gymCategory, setGymCategory] = useState([]);
  const [amenity, setAmenity] = useState([]);
  const [equipment1, setEquipment1] = useState([]);
  const [showDropdown, setShowDropdown] = useState(true);
  const [count, setCount] = useState(100);
  const logoFileInputRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const handleAmenity = async () => {
    try {
      const amenityData = await get(`${endpoints.amenity}`);
      if (amenityData?.data?.success) {
        setAmenity(amenityData?.data?.data);
      }
    } catch (e) {}
  };
  const handleEquipments = async () => {
    try {
      const equipData = await get(
        `${endpoints.equip}?&type=default&limit=${count}`
      );
      setCount(equipData?.data?.totalCount);
      if (equipData?.data?.success) {
        setEquipment1(equipData?.data?.data);
      }
    } catch (e) {}
  };
  const fetchGymsCategories = async () => {
    try {
      const response = await get(`${endpoints.gymCategory}`);
      setGymCategory(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
    } catch (error) {
      console.error("Error fetching gyms data:", error);
      setGymCategory([]);
    } finally {
    }
  };
  useEffect(() => {
    handleAmenity();
    handleEquipments();
    fetchGymsCategories();
  }, []);
  const gymId = location1.state?.gymId;

  const formik = useFormik({
    initialValues: {
      gymOwner: currentUser?.id || "",
      name: "",
      description: "",
      phoneNumber: "",
      email: "",
      googleMap: "",
      facebook: "",
      instagram: "",
      linkedin: "",
      website: "",
      location: { formatted_address: "" },
      otherFacilities: [],
      specialInfo: "",
      gymTag: [],
      gymCategory: "",
      equipment: "",
      openingSchedule: [],
      mediaFiles: [],
      amenityList: [],
      equipList: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required!"),
      description: Yup.string().required("Description is required"),
      phoneNumber: Yup.string()
        .matches(
          /^\d{11}$/,
          "Phone number must be 11 digits and contain only numbers"
        )
        .required("Phone number is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      location: Yup.object().shape({
        formatted_address: Yup.string().required("Location is required"),
      }),
      gymCategory: Yup.string().required("Please select the category!"),
      gymTag: Yup.array()
        .min(1, "At least one tag is required")
        .required("Tag is required"),
    }),

    onSubmit: async (values) => {
      try {
        if (mediaFiles.files?.length <= 0) {
          setFormError("Please select atleast one media file");
          return false;
        } else {
          setFormError("");
        }
        if (!logoFiles) {
          setLogoError("Please select upload Logo file");
          return false;
        } else {
          setLogoError("");
        }
        if (!values.gymOwner) {
          values.gymOwner = currentUser?.id;
        }
        setIsSubmitting(true);
        const formData = new FormData();
        if (values.location) {
          formData.append("location", JSON.stringify(values.location));
        }

        Object.entries(values).forEach(([key, value]) => {
          if (key !== "location") {
            formData.append(key, value);
          }
        });
        formData.set("openingSchedule", JSON.stringify(workingHours));
        mediaFiles.files.forEach((file) => formData.append("files", file));
        formData.append("logo", logoFiles);

        // if (values.amenityList && values.amenityList.length > 0) {
        //   formData.append("amenityList", JSON.stringify(values.amenityList));
        // }

        const gymResponse = await post(endpoints.gym, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (gymResponse?.data?.success) {
          toast.success("Gym Added Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          navigate("/list-gyms");
        } else if (gymResponse?.response?.data) {
          if (
            gymResponse?.response?.data?.message == "Duplicate value at name_1"
          ) {
            toast.error(
              "Oops! Gym name is already in use. Please choose a different one.",
              {
                position: "bottom-center",
                theme: "colored",
                transition: Bounce,
              }
            );
          } else {
            toast.error(gymResponse?.response?.data?.message, {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
          }
        } else {
          toast.error("Gym Added Failed", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } catch (error) {
        console.log(error, error.message);
        setApiError("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  const handleFileChange = (e, index = 0, type = "media") => {
    if (type === "logo") {
      setLogoFiles(e.target.files[0]);
    } else {
      const files = Array.from(e.target.files);
      const validFiles = files.filter(
        (file) =>
          file.type.startsWith("image/") || file.type.startsWith("video/")
      );

      if (validFiles?.length !== files?.length) {
        toast.error("Some files have invalid formats", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }

      setMediaFiles((prev) => {
        const updatedFiles = [...prev.files, ...validFiles];
        return { files: updatedFiles };
      });

      if (validFiles?.length > 0) {
        setFormError("");
      }

      // Reset the input value
      e.target.value = null;
    }
  };

  const removeMedia = (index) => {
    setMediaFiles((prev) => ({
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  const addMediaPlaceholder = () => {
    setMediaFiles((prev) => ({
      files: [...prev.files, null],
    }));
  };
  const isFileUploaded = mediaFiles.files.some((file) => file !== null);

  const addWorkingHours = () => {
    if (clickCount < 7) {
      setWorkingHours([
        ...workingHours,
        { openTime: "", closeTime: "", workingDay: "" },
      ]);
      setClickCount(clickCount + 1);
    }
  };
  const cancel = () => {
    navigate("/dashboard");
  };

  const searchGymOwner = async (search) => {
    try {
      const searchData = await get(
        `${endpoints.owner}?page=1&limit=50&search=${search}`
      );
      if (searchData?.data?.success) {
        setOwnerSearch(searchData?.data?.data);
        setOwnerloading(false);
      }
    } catch (e) {
      setOwnerloading(false);
    }
  };
  const handleInputChange = (e) => {
    setOwnerloading(true);
    setSelectedItem(true);

    const value = e.target.value;
    setOwnerSearchTxt(value);
    debouncedSearch(value);
  };
  const debouncedSearch = useCallback(
    debounce((query) => searchGymOwner(query), 500),
    []
  );
  const selectedGymOwner = (data) => {
    setSelectedOwner(data);
    setSelectedItem(false);

    setOwnerSearchTxt(
      `${data?.firstName != null ? data?.firstName : ""} ${
        data?.lastName != null ? data?.lastName : ""
      }`
    );
    formik.setFieldValue("gymOwner", data?.id || currentUser?.id);
  };
  const { appRole } = useSelector((state) => state.auth.currentUser);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "56px",
      borderRadius: "80px",
      backgroundColor: "#f8f9fa",
      border: "none",
      boxShadow: "none",
      paddingLeft: "15px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "rgba(59, 171, 166, 0.35)",
      borderRadius: "5px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      marginTop: "4px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(59, 171, 166, 0.35)"
        : state.isFocused
        ? "#e9ecef"
        : "transparent",
      color: state.isSelected ? "#fff" : "#000",
    }),
  };
  const resetFileInputs = (type = "media") => {
    if (type === "logo" && logoFileInputRef.current) {
      logoFileInputRef.current.value = "";
      setLogoFiles(null);
    }
  };
  const [fullDay, setFullDay] = useState(false);
  const handleFullDay = () => {
    setDay(!day);
  };
  return (
    <div className=" mb-5 ">
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4">
              <form className="p-4" onSubmit={formik.handleSubmit}>
                <h3 className="ff-sora font-size-20 fw-bold primary-black ">
                  {gymId ? "Edit Gym" : "Add New Gym"}
                </h3>
                <FormGroup>
                  <Label className="ff-sora font-size-16 fw-normal secondary-black">
                    Logo <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex flex-wrap gap-2">
                    <div
                      className="position-relative cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                      style={{
                        border: "1px dashed #ccc",
                        width: "160px",
                        height: "160px",
                      }}
                    >
                      {logoFiles ? (
                        logoFiles.type.startsWith("image/") && (
                          <img
                            src={URL.createObjectURL(logoFiles)}
                            alt={`Preview ${logoFiles}`}
                            className="w-100 h-100 object-fit-cover rounded"
                          />
                        )
                      ) : (
                        <div
                          className="d-flex justify-content-center align-items-center flex-column text-center"
                          onClick={() => logoFileInputRef.current.click()}
                        >
                          <img
                            src={newImgIcon}
                            alt="Upload"
                            className="d-flex"
                            style={{
                              height: "40px",
                              width: "40px",
                            }}
                          />
                          <div className="ff-sora font-size-16 fw-normal secondary-black">
                            Upload logo
                          </div>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        ref={logoFileInputRef}
                        className="d-none"
                        onChange={(e) => handleFileChange(e, 0, "logo")}
                      />
                      {logoFiles && (
                        <button
                          type="button"
                          className="border-0 rounded-2 bg-light cursor-pointer d-flex justify-content-center align-items-center"
                          style={{
                            left: "83%",
                            width: "20px",
                            height: "20px",
                            position: "absolute",
                            top: 10,
                            right: 30,
                          }}
                          onClick={() => resetFileInputs("logo")}
                        >
                          X
                        </button>
                      )}
                    </div>
                  </div>
                  {logoError && <div className="text-danger">{logoError}</div>}
                </FormGroup>
                {/* Media File Input */}
                <FormGroup>
                  <Label className="ff-sora font-size-16 fw-normal secondary-black">
                    Media <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex flex-wrap gap-2">
                    {mediaFiles.files.map((file, index) => (
                      <div
                        key={index}
                        className="position-relative cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                        style={{
                          border: "1px dashed #ccc",
                          width: "160px",
                          height: "160px",
                        }}
                      >
                        {file ? (
                          file.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`Preview ${index}`}
                              className="w-100 h-100 object-fit-cover rounded"
                            />
                          ) : (
                            <video
                              src={URL.createObjectURL(file)}
                              className="w-100 h-100 rounded"
                              controls
                            />
                          )
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center flex-column text-center"
                            onClick={() =>
                              document
                                .getElementById(`fileInput-${index}`)
                                .click()
                            }
                          >
                            <img
                              src={index === 0 ? imgupload : newImgIcon}
                              alt="Upload"
                              className="d-flex"
                              style={{
                                height: "40px",
                                width: "40px",
                              }}
                            />
                            <div className="ff-sora font-size-16 fw-normal secondary-black">
                              {index === 0
                                ? "Upload Media"
                                : "Upload More Media"}
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/*,video/*"
                          id={`fileInput-${index}`}
                          multiple
                          className="d-none"
                          onChange={(e) => handleFileChange(e, index, "media")}
                        />
                        {file && (
                          <button
                            type="button"
                            className="border-0 rounded-2 bg-light cursor-pointer d-flex justify-content-center align-items-center"
                            style={{
                              left: "83%",
                              width: "20px",
                              height: "20px",
                              position: "absolute",
                              top: 10,
                              right: 30,
                            }}
                            onClick={() => removeMedia(index)}
                          >
                            X
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  {formError && <div className="text-danger">{formError}</div>}
                </FormGroup>

                {(appRole === "admin" || appRole === "staff") && (
                  <>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Assign Gym Owner
                    </h5>

                    <FormGroup>
                      <Input
                        type="text"
                        name="name"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        placeholder="Select Gym Owner"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={ownerSearchTxt}
                        onChange={(e) => {
                          setOwnerSearchTxt(e.target.value);
                          handleInputChange(e);
                        }}
                        onClick={(e) => {
                          setShowDropdown(true);
                          setOwnerSearchTxt(e.target.value);
                          handleInputChange(e);
                        }}
                        onFocus={() => setShowDropdown(true)}
                      />
                      {formik.errors.gymOwner && (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.gymOwner}
                        </div>
                      )}
                    </FormGroup>

                    {/* Dropdown */}
                    {(ownerloading || (selectedItem && !ownerloading)) &&
                      showDropdown && (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <ul
                            style={{
                              listStyle: "none",
                              borderRadius: "10px",
                              border: "1px solid #eaeced",
                              padding: "10px",
                              maxHeight: "200px",
                              overflowY: "auto",
                              marginTop: "8px",
                              background: "#fff",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {/* Loading State */}
                            {ownerloading && ownerSearch?.length <= 0 && (
                              <li className="d-flex align-items-center gymOwnerContainer">
                                <p className="text-center ff-sora fw-normal font-size-16">
                                  Loading...
                                </p>
                              </li>
                            )}

                            {/* Search Results */}
                            {ownerSearch
                              .filter((item) =>
                                `${item.firstName} ${item.lastName}`
                                  .toLowerCase()
                                  .includes(ownerSearchTxt.toLowerCase())
                              )
                              .map((item, index) => (
                                <li
                                  key={index}
                                  onClick={() => {
                                    selectedGymOwner(item); // Handle selection
                                    formik.setFieldValue("gymOwner", item.id); // Update Formik value
                                    setShowDropdown(false); // Close dropdown on selection
                                  }}
                                  className="d-flex align-items-center gymOwnerContainer"
                                  style={{
                                    padding: "10px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    transition: "background-color 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#f7f7f7")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "transparent")
                                  }
                                >
                                  <img
                                    className="gymOwnerImage"
                                    src={
                                      item?.additionalInfo?.profileImage
                                        ? process.env.REACT_APP_IMG_URL +
                                          item?.additionalInfo?.profileImage
                                        : avatar
                                    }
                                    alt="Gym Owner"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      marginRight: "10px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <p className="m-0 font-size-16 tertiary-black ff-sora">
                                    {item.firstName} {item.lastName}
                                  </p>
                                </li>
                              ))}
                          </ul>

                          {/* Close Button */}
                          <button
                            onClick={() => setShowDropdown(false)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "16px",
                              color: "#333",
                            }}
                          >
                            ✖
                          </button>
                        </div>
                      )}
                  </>
                )}
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Gym Info <span className="text-danger">*</span>
                </h5>
                <FormGroup>
                  <Input
                    type="text"
                    name="name"
                    style={{
                      height: "56px",
                      border: "none",
                    }}
                    placeholder="Gym/Club name"
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </FormGroup>

                <FormGroup>
                  <Input
                    type="textarea"
                    name="description"
                    placeholder="Description"
                    className="rounded-4 bg-light pb-5 ff-sora font-size-16 fw-normal tertiary-black px-4 border-none"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </FormGroup>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Contact Info <span className="text-danger">*</span>
                </h5>
                <Row form>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="text"
                        name="phoneNumber"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        placeholder="Phone number"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phoneNumber &&
                      formik.errors.phoneNumber ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.phoneNumber}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="email"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="email"
                        placeholder="Email"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.email}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="text"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="website"
                        placeholder="Website"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.website}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Location <span className="text-danger">*</span>
                </h5>
                <FormGroup>
                  <Autocomplete
                    apiKey="AIzaSyCMj0TE0Q3eOujTHxhTUhMOiLX0KVRSIGM"
                    name="location"
                    style={{
                      height: "56px",
                      border: "none",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    placeholder="Location"
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black form-control px-4"
                    enablePoweredByContainer={false}
                    onPlaceSelected={(place) => {
                      if (place && place.formatted_address) {
                        formik.setFieldValue("location", {
                          formatted_address: place.formatted_address,
                          address_components: place.address_components.map(
                            (component) => ({
                              long_name: component.long_name,
                              short_name: component.short_name,
                              types: component.types,
                            })
                          ),
                          geometry: place.geometry,
                        });
                      }
                    }}
                    value={formik.values.location?.formatted_address || ""}
                    onChange={(e) => {
                      formik.setFieldValue("location", {
                        formatted_address: e.target.value,
                      });
                    }}
                    onBlur={() => {
                      if (!formik.values.location?.geometry) {
                        formik.setFieldValue("location", "");
                      }
                      formik.handleBlur("location");
                    }}
                    options={{
                      types: ["address"],
                    }}
                  />

                  {formik.touched?.location?.formatted_address &&
                  formik.errors?.location?.formatted_address ? (
                    <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                      {formik.errors?.location?.formatted_address}
                    </div>
                  ) : null}
                </FormGroup>
                <Row>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Category <span className="text-danger">*</span>
                    </h5>
                    <FormGroup>
                      <div className="position-relative">
                        <select
                          name="gymCategory"
                          style={{
                            height: "56px",
                            border: "none",
                          }}
                          className="form-select rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          value={formik.values.gymCategory}
                          onChange={(e) => {
                            formik.setFieldValue("gymCategory", e.target.value);
                          }}
                          onBlur={formik.handleBlur}
                        >
                          {formik.values.gymCategory == "" && (
                            <option value="" disabled style={{ opacity: 0 }}>
                              Select Category
                            </option>
                          )}
                          {gymCategory?.map((tag) => (
                            <option key={tag.id} value={tag.id}>
                              {tag.title}
                            </option>
                          ))}
                        </select>
                      </div>

                      {formik.touched.gymCategory &&
                      formik.errors.gymCategory ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.gymCategory}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Tags <span className="text-danger">*</span>
                    </h5>
                    <FormGroup>
                      <div className="position-relative">
                        <Input
                          type="select"
                          name="gymTag"
                          className="d-none"
                          multiple
                          value={formik.values.gymTag}
                          onChange={formik.handleChange}
                        />

                        <div
                          className="d-flex flex-wrap gap-2 align-items-center bg-light rounded-5 p-2 min-h-56"
                          style={{ minHeight: "56px" }}
                        >
                          {formik.values.gymTag?.map((tag) => (
                            <span
                              key={tag}
                              className="badge bg-brand-orange text-dark py-2 px-3 rounded-5 cursor-pointer font-size-14 fw-normal d-flex align-items-center gap-1"
                              onClick={() => {
                                formik.setFieldValue(
                                  "gymTag",
                                  formik.values.gymTag.filter((t) => t !== tag)
                                );
                              }}
                            >
                              {tag} <span>&times;</span>
                            </span>
                          ))}

                          {formik.values.gymTag?.length < 3 && (
                            <Dropdown
                              isOpen={dropdownOpen}
                              toggle={toggleDropdown}
                            >
                              <DropdownToggle
                                tag="div"
                                className="rounded-5 border-0 bg-transparent shadow-none p-2 cursor-pointer d-flex align-items-center"
                                data-toggle="dropdown"
                                aria-expanded={dropdownOpen}
                              >
                                <span className="me-1 ff-sora font-size-16 fw-normal secondary-black">
                                  + Add Tag
                                </span>
                              </DropdownToggle>
                              <DropdownMenu className="rounded-5">
                                {["NEWGYM", "NOTEWORTHY", "MOSTLOVED"]
                                  .filter(
                                    (tag) => !formik.values.gymTag.includes(tag)
                                  )
                                  .map((tag) => (
                                    <DropdownItem
                                      key={tag}
                                      onClick={() => {
                                        const newTags = [
                                          ...formik.values.gymTag,
                                          tag,
                                        ];
                                        formik.setFieldValue("gymTag", newTags);
                                      }}
                                      className="ff-sora font-size-16 fw-normal"
                                    >
                                      {tag}
                                    </DropdownItem>
                                  ))}
                              </DropdownMenu>
                            </Dropdown>
                          )}
                        </div>
                      </div>

                      {formik.touched.gymTag && formik.errors.gymTag && (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.gymTag}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Google Map Link
                    </h5>
                    <FormGroup>
                      <Input
                        type="url"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="googleMap"
                        placeholder="GoogleMap link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.googleMap}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.googleMap && formik.errors.googleMap ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.googleMap}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Facebook
                    </h5>
                    <FormGroup>
                      <Input
                        type="facebook"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="facebook"
                        placeholder="Facebook link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.facebook}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.facebook && formik.errors.facebook ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.facebook}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Instagram
                    </h5>
                    <FormGroup>
                      <Input
                        type="instagram"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="instagram"
                        placeholder="Instagram link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.instagram}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.instagram && formik.errors.instagram ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.instagram}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Working Hours
                </h5>
                {workingHours.map((obj, index) => (
                  <Row
                    form
                    key={index}
                    className="d-flex align-items-center mb-3"
                  >
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          type="select"
                          style={{ height: "56px", border: "none" }}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          value={obj.workingDay}
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].workingDay = e.target.value;
                            setWorkingHours(newHours);
                          }}
                        >
                          <option>Select day</option>
                          <option>Monday</option>
                          <option>Tuesday</option>
                          <option>Wednesday</option>
                          <option>Thursday</option>
                          <option>Friday</option>
                          <option>Saturday</option>
                          <option>Sunday</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          disabled={obj.isFullDay}
                          type="time"
                          style={{ height: "56px", border: "none" }}
                          value={obj.isFullDay ? "00:00" : obj.openTime}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          placeholder="Start time"
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].openTime = obj.isFullDay
                              ? "00:00"
                              : e.target.value;
                            setWorkingHours(newHours);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          disabled={obj.isFullDay}
                          type="time"
                          value={obj.isFullDay ? "00:00" : obj.closeTime}
                          style={{ height: "56px", border: "none" }}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          placeholder="Close Time"
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].closeTime = obj.isFullDay
                              ? "00:00"
                              : e.target.value;
                            setWorkingHours(newHours);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup className="d-flex align-items-center">
                        <Label
                          check
                          className="d-flex align-items-center ff-sora font-size-16 fw-normal secondary-black"
                        >
                          <Input
                            type="checkbox"
                            checked={obj.isFullDay}
                            onChange={(e) => {
                              const newHours = [...workingHours];
                              newHours[index] = {
                                ...newHours[index],
                                isFullDay: e.target.checked,
                                openTime: e.target.checked ? "00:00" : "",
                                closeTime: e.target.checked ? "00:00" : "",
                              };
                              setWorkingHours(newHours);
                            }}
                            className="mx-2"
                            style={{
                              border: "1px solid black",
                              height: "25px",
                              width: "25px",
                            }}
                          />
                          Open 24-Hours
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col
                      md={3}
                      className="d-flex justify-content-between mb-3 flex-md-column flex-xxl-row"
                    >
                      <a
                        className="rounded-pill1 text-sub-black fw-normal font-size-16 ff-sora cursor-pointer"
                        onClick={addWorkingHours}
                        disabled={clickCount >= 6}
                        style={{
                          display: clickCount >= 6 ? "none" : "inline-block",
                        }}
                      >
                        + Add Hours
                      </a>
                      <a
                        className="rounded-pill1 text-sub-black fw-normal font-size-16 ff-sora cursor-pointer mt-md-2 mt-xxl-0 ms-xl-1"
                        onClick={() => {
                          if (workingHours?.length === 1) {
                            const updatedHours = [
                              {
                                openTime: "",
                                closeTime: "",
                                workingDay: "",
                                isFullDay: false,
                              },
                            ];
                            setWorkingHours(updatedHours);
                          } else {
                            const updatedHours = workingHours.filter(
                              (_, i) => i !== index
                            );
                            setWorkingHours(updatedHours);
                            setClickCount(clickCount - 1);
                          }
                        }}
                      >
                        Remove
                      </a>
                    </Col>
                  </Row>
                ))}
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Amenities
                </h5>
                <FormGroup>
                  <Select
                    name="amenitiesList"
                    styles={customStyles}
                    options={amenity}
                    value={amenity.filter((option) =>
                      formik.values.amenityList.includes(option.id)
                    )}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions
                        ? selectedOptions.map((option) => option.id)
                        : [];
                      formik.setFieldValue("amenityList", selectedValues);
                    }}
                    onBlur={formik.handleBlur}
                    isMulti
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center ff-sora font-size-16 fw-normal">
                        <img
                          src={
                            e.image == null
                              ? avatar
                              : `${process.env.REACT_APP_IMG_URL}${e.image}`
                          }
                          alt={e.name}
                          className="object-fit-contain"
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                          }}
                        />
                        <span className="ff-sora font-size-16 fw-normal">
                          {e.name}
                        </span>
                      </div>
                    )}
                    getOptionValue={(e) => e.id}
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black "
                    placeholder="Select Amenity"
                  />
                </FormGroup>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Add Equipments
                </h5>
                <FormGroup>
                  <Select
                    name="equipmentList"
                    styles={customStyles}
                    options={equipment1}
                    value={equipment1.filter((option) =>
                      formik.values.equipList.includes(option.id)
                    )}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions
                        ? selectedOptions.map((option) => option.id)
                        : [];
                      formik.setFieldValue("equipList", selectedValues);
                    }}
                    onBlur={formik.handleBlur}
                    isMulti
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center ff-sora font-size-16 fw-normal">
                        <img
                          src={
                            e.file == null
                              ? avatar
                              : `${process.env.REACT_APP_IMG_URL}${e.file}`
                          }
                          alt={e.name}
                          className="object-fit-contain"
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                          }}
                        />
                        <span className="ff-sora font-size-16 fw-normal">
                          {e.name}
                        </span>
                      </div>
                    )}
                    getOptionValue={(e) => e.id}
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black "
                    placeholder="Select Admin Equiment"
                  />
                </FormGroup>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Special Info
                </h5>
                <FormGroup>
                  <ReactQuill
                    value={formik.values.specialInfo}
                    name="specialInfo"
                    placeholder="Special Info"
                    onChange={(state) =>
                      formik.setFieldValue("specialInfo", state)
                    }
                    onBlur={() => formik.setFieldTouched("specialInfo", true)}
                    theme="snow"
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        [{ font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline", "strike"],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        ["link", "image"],
                        ["clean"],
                      ],
                      imageDrop: true,
                      resize: { locale: {} },
                      clipboard: true,
                    }}
                    formats={[
                      "header",
                      "font",
                      "list",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "color",
                      "background",
                      "align",
                      "link",
                      "image",
                    ]}
                    className="custom-editor"
                  />
                  {formik.errors?.specialInfo &&
                    formik.touched?.specialInfo && (
                      <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                        {formik.errors.specialInfo}
                      </div>
                    )}
                </FormGroup>

                {/* <FormGroup>
                  <Input
                    type="textarea"
                    name="specialInfo"
                    placeholder="Special Info"
                    className="rounded-4 bg-light pb-5 ff-sora border-none font-size-16 fw-normal tertiary-black px-4"
                    value={formik.values.specialInfo}
                    style={{
                      border: "none",
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FormGroup> */}
                <div className="d-flex float-end">
                  <Button
                    type="submit"
                    className="me-2 rounded-pill"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Add Gym"
                    )}
                  </Button>
                  <Button
                    color="white"
                    className="rounded-pill1"
                    onClick={cancel}
                  >
                    Cancel
                  </Button>
                </div>
                {apiError && <div className="text-danger mt-2">{apiError}</div>}
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddGyms;
